export default __webpack_public_path__ + "static/media/Icon-Modal-Close.9a85709f.svg";